import { armorAPI } from '~/services/api';

const createFilterGroup = (payload: { filter_criteria: unknown[]; name: string }) =>
  armorAPI.request({
    data: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: 'orderviews/',
  });

const getFilterGroups = () =>
  armorAPI.request({
    method: 'GET',
    url: 'orderviews/',
  });

const deleteFilterGroup = (filterGroupObjectID: string) =>
  armorAPI.request({
    method: 'DELETE',
    url: `orderviews/${filterGroupObjectID}/`,
  });

export { createFilterGroup, deleteFilterGroup, getFilterGroups };
